import PageHeader from '@/components/common/PageHeader';

const PrivacyPolicyPage = () => {
  return (
    <div data-testid="privacy-policy-page">
      <PageHeader 
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your personal information"
        breadcrumbs={[{ label: 'Privacy Policy' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-gray-600 mb-8">
              <strong>Last Updated: January 1, 2026</strong>
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">1. Introduction</h2>
            <p className="text-gray-600 mb-6">
              Zafco Human Resource Management ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
              you visit our website www.zafco.in and use our overseas recruitment services.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">2. Information We Collect</h2>
            <h3 className="text-xl font-semibold text-zafco-blue mb-3">Personal Information</h3>
            <p className="text-gray-600 mb-4">We may collect personal information that you voluntarily provide, including:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Name, email address, and phone number</li>
              <li>Educational qualifications and work experience</li>
              <li>Passport and identity documents</li>
              <li>Immigration history and visa applications</li>
              <li>Financial information for proof of funds</li>
              <li>Language test scores (IELTS, PTE, etc.)</li>
            </ul>

            <h3 className="text-xl font-semibold text-zafco-blue mb-3">Automatically Collected Information</h3>
            <p className="text-gray-600 mb-6">
              When you visit our website, we may automatically collect certain information including your IP address, 
              browser type, operating system, referring URLs, and pages viewed.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">3. How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Provide overseas recruitment and immigration services</li>
              <li>Assess your eligibility for various visa programs</li>
              <li>Communicate with you about your application status</li>
              <li>Send updates about immigration policies and opportunities</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">4. Information Sharing</h2>
            <p className="text-gray-600 mb-6">
              We may share your information with immigration authorities, government agencies, and third-party 
              service providers (such as skills assessment bodies) as required for your application. We do not 
              sell your personal information to third parties.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">5. Data Security</h2>
            <p className="text-gray-600 mb-6">
              We implement appropriate technical and organizational measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
              over the Internet is 100% secure.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">6. Your Rights</h2>
            <p className="text-gray-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for marketing communications</li>
              <li>Lodge a complaint with data protection authorities</li>
            </ul>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">7. Contact Us</h2>
            <p className="text-gray-600 mb-6">
              For any questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <p className="text-gray-600 mb-6">
              <strong>Zafco Human Resource Management</strong><br />
              Ground Floor 5, Building No. 27B,<br />
              Khizrabad, New Friends Colony,<br />
              New Delhi - 110025<br />
              Phone: +91-9958848998<br />
              Email: info@zafco.in
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
